import './styles.scss';

// main.js is asynchronously loaded to fix the error: 'Shared module is not available for eager consumption' while integrating "RetailConfigurator" in "RemoteBuildAndPrice"
// Reference of fix: https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption
import('./main.js');